import React, { useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Box, TextField, Typography } from '@mui/material';
import { Button } from '@mui/joy';

const JobDetailsForm = () => {
    const [date, setDate] = useState(null);
    return (
        <Box>
            <form action="">
                <Typography variant="h5" mt={3}>Location</Typography>
                <TextField variant="outlined" fullWidth sx={{ height: '40px', my: 2 }} />


                <Typography variant="h5" mb={1}>
                    Description <span style={{ color: '#666666' }}>(optional)</span>
                </Typography>
                <TextField multiline rows={6} fullWidth variant="outlined" />

                <Typography variant="h5" mb={1}>
                    Place Your Bid
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label="Select Date"
                        value={date}
                        onChange={(newValue) => setDate(newValue)}
                        renderInput={(params) => (
                            <TextField {...params} placeholder="SelectaDate" fullWidth />
                        )}
                    />
                </LocalizationProvider>

                <Box sx={{ display: 'flex', justifyContent: "center", justifyItems: "center" }}>

                    <Button
                        sx={{
                            padding: "12px", width: "250px", textAlign: "center",
                            backgroundColor: "#28A745",
                            "&:hover": {
                                backgroundColor: "#28A745",
                                color: "#ffffff", boxShadow: 3,
                            },

                        }}>Place Bid</Button>
                </Box>
            </form>
        </Box>
    )
}

export default JobDetailsForm;